import { type LodManifest, MAX_LOD_SWITCH_DISTANCE, parseLodDistances } from "@repo/api/src/schemas/lod";

/** Editing candidates only. An unset override keeps the engine's automatic policy. */
export function suggestedLodDistances(transitions: number): string[] {
	const base = Math.min(5, MAX_LOD_SWITCH_DISTANCE / 3 ** Math.max(0, transitions - 1));
	return Array.from({ length: transitions }, (_, index) => String(Number((base * 3 ** index).toPrecision(8))));
}

export function validateLodDistanceInputs(values: string[] | null, levels: number, ja: boolean): string | null {
	if (values === null) return null;
	try {
		parseLodDistances(values.map(Number), levels);
		return null;
	} catch {
		return ja
			? "距離は0より大きく、1,000,000以下にしてください。番号が大きいLODほど、距離を大きくしてください。"
			: "Distances must be greater than 0 and at most 1,000,000, increasing with each LOD level.";
	}
}

export function lodManifestRatios(manifest: LodManifest): number[] | undefined {
	const counts = Array<number>(manifest.lodLevels).fill(0);
	const pending = [manifest.tree];
	while (pending.length) {
		const node = pending.pop() as { children?: unknown[]; lods?: Record<string, { count: number }> };
		if (node.children) pending.push(...node.children);
		else for (const [level, entry] of Object.entries(node.lods ?? {})) counts[Number(level)] += entry.count;
	}
	if (!counts[0] || counts.some((count, index) => count <= 0 || (index > 0 && count >= counts[index - 1])))
		return undefined;
	return counts.slice(1).map(count => count / counts[0]);
}
